<template>
  <div style="padding: 0; margin: 0; height: 100%;">
    <div v-loading="loading" element-loading-text="加载中..." class="app-container">
      <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
        <template slot="header">
          <el-row :gutter="10" class="filter-container">
            <el-col :xs="24" :sm="6">
              <el-input v-model="queryParams.keyword" class="filter-item" placeholder="用户昵称、手机号或分享码" clearable />
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.status" class="filter-item" placeholder="状态" clearable>
                <el-option label="禁用" :value="0" />
                <el-option label="启用" :value="1" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            </el-col>
          </el-row>
        </template>

        <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户昵称" prop="nickName" min-width="120">
            <template slot-scope="{row}">{{ row.nickName | filterMemberName }}</template>
          </el-table-column>
          <el-table-column label="手机号" prop="mobile" min-width="120" />
          <el-table-column label="分享码" prop="shareCode" min-width="80" />
          <el-table-column label="身份等级" prop="gradeName" align="center" width="100" />
          <el-table-column label="消费等级" prop="consumerName" align="center" width="100" />
          <el-table-column label="合伙人身份" align="center" width="100">
            <template slot-scope="{row}">{{ row.partnership | filterPartnership }}</template>
          </el-table-column>
          <el-table-column label="邀请人" prop="inviterName" min-width="120" />
          <el-table-column label="注册时间" prop="createTime" min-width="150" />
          <el-table-column align="center" width="80" fixed="right">
            <template slot-scope="{row}">
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="commandValue('detail', row.id)">用户详情</el-dropdown-item>
                  <el-dropdown-item divided :command="commandValue('inviter', row)">更改推荐人</el-dropdown-item>
                  <el-dropdown-item divided :command="commandValue('partnership', row)">更改合伙人身份</el-dropdown-item>
                  <el-dropdown-item v-if="row.partnership" :command="commandValue('cancel', row.id)">取消合伙人身份</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
      </el-card>
    </div>

    <el-dialog title="用户详情" top="5vh" width="600px" :visible.sync="detailDialog">
      <member-detail :member-id="memberId" />

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailClose">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="更改合伙人身份" width="320px" :visible.sync="partnerDialog">
      <el-form ref="partnerForm" :model="detail" :rules="partnerRules" label-width="100px">
        <el-form-item label="用户昵称">
          <el-input disabled :value="detail.nickName" />
        </el-form-item>
        <el-form-item label="合伙人身份" prop="partnership">
          <el-select v-model="detail.partnership" placeholder="请选择合伙人身份">
            <el-option label="合作商" :value="3" />
            <el-option label="联盟企业" :value="4" />
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailClose">取 消</el-button>
        <el-button type="primary" @click="confirmPartnership">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberList, changePartnership } from '@/api/member'
import { StickyHeader } from '@cell-x/el-table-sticky'
import Pagination from '@/components/Pagination'
import memberDetail from './detail'

export default {
  name: 'MemberStore',
  components: { Pagination, memberDetail },
  filters: {
    filterMemberName: (memberName) => {
      return memberName || '慧生活用户'
    },
    filterPartnership: (level) => {
      return level === 3 ? '合作商' : (level === 4 ? '联盟企业' : '')
    }
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      detail: {},
      loading: false,
      queryParams: {
        keyword: '',
        userGrade: '',
        consumerLevel: '',
        partnership: 3,
        status: '',
        page: 1,
        limit: 20
      },
      partnerDialog: false,
      detailDialog: false,
      memberId: '',
      partnerRules: {
        partnership: [{ required: true, message: '请选择合伙人身份', trigger: 'change' }]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      getMemberList(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 1000)
      })
    },
    commandValue(command, row) {
      return {
        data: row,
        command: command
      }
    },
    handleCommand(commandValue) {
      const { data, command } = commandValue
      if (command === 'detail') { // 用户详情
        this.memberId = data
        this.detailDialog = true
      } else if (command === 'inviter') { // 更改推荐人
      } else if (command === 'partnership') { // 更改合伙人身份
        this.detail = Object.assign({}, data)
        this.detail.partnership = data.partnership === 0 ? '' : data.partnership
        this.partnerDialog = true
      } else if (command === 'cancel') {  // 取消合伙人身份
      }
    },
    detailClose() {
      this.partnerDialog = false
      this.detailDialog = false
      this.memberId = ''
      this.detail = {}
    },
    confirmPartnership() {
      if (!this.detail.partnership) return this.$message.warning('请选择合伙人身份')
      this.$refs.partnerForm.validate(valid => {
        if (!valid) return false
        const data = {
          id: this.detail.id,
          partnership: this.detail.partnership
        }
        changePartnership(data).then(response => {
          if (response) {
            this.$message.success('更改合伙人身份成功')
            this.detailClose()
            this.fetchData()
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
